export enum FinanceType {
  Money = 'Money',
  Units = 'Units',
}
